export const PERMS = {
    READ: 'vehicle_events.read',
    UPDATE: 'vehicle_events.update',
    DELETE: 'vehicle_events.delete',
    CREATE: 'vehicle_events.create',
}
